import { render, staticRenderFns } from "./Toolbar.vue?vue&type=template&id=5d55dfe6&scoped=true&"
var script = {}
import style0 from "./Toolbar.vue?vue&type=style&index=0&id=5d55dfe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d55dfe6",
  null
  
)

export default component.exports